module.exports = __webpack_public_path__ + "static/media/solicitudagregada.c426d472.svg";